// // import React, { useState, useEffect } from 'react';
// // import axios from 'axios';
// // import LeftSideNavaBarAdmin from './LeftSideNavaBarAdmin';

// // const Product = () => {
// //     const [categories, setCategories] = useState([]);
// //     const [productName, setProductName] = useState([]);
// //     const [selectedCategory, setSelectedCategory] = useState('');
// //     const [selectedproductName, setSelectedProductName] = useState('');
// //     const [Aroma, setAroma] = useState('');
// //     const [caption, setCaption] = useState('');
// //     const [description, setDescription] = useState('');
// //     const [users, setUsers] = useState('');
// //     const [sizes, setSizes] = useState([{ size: '', quantity: '', price: '', offer: '', sellingPrice: '' }]);
// //     const [images, setImages] = useState([]);
// //     const [message, setMessage] = useState('');

// //     // Fetch categories
// //     useEffect(() => {
// //         const fetchCategories = async () => {
// //             try {
// //                 const response = await axios.get('/api/categories');
// //                 setCategories(response.data);
// //             } catch (error) {
// //                 console.error('Error fetching categories:', error);
// //             }
// //         };
// //         fetchCategories();
// //     }, []);

// //     // Fetch productName when a category is selected
// //     useEffect(() => {
// //         if (selectedCategory) {
// //             const fetchProducts = async () => {
// //                 try {
// //                     const response = await axios.get(`/api/products/${selectedCategory}`);
// //                     setProductName(response.data);
// //                 } catch (error) {
// //                     console.error('Error fetching productName:', error);
// //                 }
// //             };
// //             fetchProducts();
// //         } else {
// //             setProductName([]);
// //         }
// //     }, [selectedCategory]);

// //     const handleAddSize = () => {
// //         setSizes([...sizes, { size: '', quantity: '', price: '', offer: '', sellingPrice: '' }]);
// //     };

// //     const handleSizeChange = (index, field, value) => {
// //         const updatedSizes = [...sizes];
// //         updatedSizes[index][field] = value;

// //         // Auto-calculate selling price
// //         if (field === 'price' || field === 'offer') {
// //             const price = parseFloat(updatedSizes[index].price || 0);
// //             const offer = parseFloat(updatedSizes[index].offer || 0);
// //             updatedSizes[index].sellingPrice = price - (price * (offer / 100));
// //         }

// //         setSizes(updatedSizes);
// //     };

// //     const handleImageChange = (e) => {
// //         setImages([...e.target.files]);
// //     };

// //     const handleSubmit = async (e) => {
// //         e.preventDefault();

// //         const formData = new FormData();
// //         formData.append('categoryId', selectedCategory);
// //         formData.append('subcategoryId', selectedproductName);
// //         formData.append('Aroma', Aroma);
// //         formData.append('caption', caption);
// //         formData.append('description', description);
// //         formData.append('users', users);
// //         formData.append('sizes', JSON.stringify(sizes));

// //         for (let image of images) {
// //             formData.append('images', image);
// //         }

// //         try {
// //             const response = await axios.post('/api/add-product', formData, {
// //                 headers: { 'Content-Type': 'multipart/form-data' },
// //             });

// //             setMessage('Product added successfully!');
// //             setAroma('');
// //             setCaption('');
// //             setDescription('');
// //             setUsers('');
// //             setSizes([{ size: '', quantity: '', price: '', offer: '', sellingPrice: '' }]);
// //             setImages([]);
// //         } catch (error) {
// //             setMessage('Failed to add product.');
// //             console.error(error);
// //         }
// //     };

// //     return (
// //         <div>
// //             <div className="content-wrapper">
// //                 <LeftSideNavaBarAdmin />
// //                 <div className="admin-product-form">
// //                     <h2>Add Product</h2>
// //                     <form onSubmit={handleSubmit}>
// //                         <label>Category:</label>
// //                         <select
// //                             value={selectedCategory}
// //                             onChange={(e) => setSelectedCategory(e.target.value)}
// //                             required
// //                         >
// //                             <option value="">Select a Category</option>
// //                             {categories.map((category) => (
// //                                 <option key={category.categoryId} value={category.categoryId}>
// //                                     {category.categoryName}
// //                                 </option>
// //                             ))}
// //                         </select>

// //                         <label>Product Name:</label>
// //                         <select
// //                             value={selectedproductName}
// //                             onChange={(e) => setSelectedProductName(e.target.value)}
// //                             required
// //                             disabled={!selectedCategory}
// //                         >
// //                             <option value="">Select a Subcategory</option>
// //                             {productName.map((products) => (
// //                                 <option key={products.subcategoryId} value={products.subcategoryId}>
// //                                     {products.productName}
// //                                 </option>
// //                             ))}
// //                         </select>

// //                         <label>Aroma:</label>
// //                         <input
// //                             type="text"
// //                             value={Aroma}
// //                             onChange={(e) => setAroma(e.target.value)}
// //                             required
// //                         />

// //                         <label>Caption:</label>
// //                         <input
// //                             type="text"
// //                             value={caption}
// //                             onChange={(e) => setCaption(e.target.value)}
// //                         />

// //                         <label>Description:</label>
// //                         <textarea
// //                             value={description}
// //                             onChange={(e) => setDescription(e.target.value)}
// //                         ></textarea>

// //                         <label>Users:</label>
// //                         <textarea
// //                             value={users}
// //                             onChange={(e) => setUsers(e.target.value)}
// //                         ></textarea>

// //                         <h3>Sizes:</h3>
// //                         {sizes.map((size, index) => (
// //                             <div key={index}>
// //                                 <input
// //                                     type="text"
// //                                     placeholder="Size"
// //                                     value={size.size}
// //                                     onChange={(e) => handleSizeChange(index, 'size', e.target.value)}
// //                                 />
// //                                 <input
// //                                     type="number"
// //                                     placeholder="Quantity"
// //                                     value={size.quantity}
// //                                     onChange={(e) => handleSizeChange(index, 'quantity', e.target.value)}
// //                                 />
// //                                 <input
// //                                     type="number"
// //                                     placeholder="Price"
// //                                     value={size.price}
// //                                     onChange={(e) => handleSizeChange(index, 'price', e.target.value)}
// //                                 />
// //                                 <input
// //                                     type="number"
// //                                     placeholder="Offer (%)"
// //                                     value={size.offer}
// //                                     onChange={(e) => handleSizeChange(index, 'offer', e.target.value)}
// //                                 />
// //                                 <input
// //                                     type="number"
// //                                     placeholder="Selling Price"
// //                                     value={size.sellingPrice}
// //                                     readOnly
// //                                 />
// //                             </div>
// //                         ))}
// //                         <button type="button" onClick={handleAddSize}>Add Size</button>

// //                         <label>Images:</label>
// //                         <input
// //                             type="file"
// //                             multiple
// //                             onChange={handleImageChange}
// //                         />

// //                         <button type="submit">Add Product</button>
// //                     </form>
// //                     {message && <p>{message}</p>}
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // export default Product;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import LeftSideNavaBarAdmin from './LeftSideNavaBarAdmin';
// import './AddProduct.css';
// import { 
//     Package,
//     Tags,
//     FileText, 
//     Users, 
//     Image as ImageIcon,
//     Ruler,
//     Plus,
//     Save,
//     Layers,
//     AlertCircle,
//     CheckCircle2
//   } from 'lucide-react';
// const Product = () => {
//     const [categories, setCategories] = useState([]);
//     const [productName, setProductName] = useState([]);
//     const [productCode, setproductCode] = useState([]);
//     const [selectedCategory, setSelectedCategory] = useState('');


//     const [selectedCategoryDetails, setSelectedCategoryDetails] = useState({
//         categoryId: '',
//         categoryName: '',
//         categoryCode: ''
//     });
//     const [selectedProductDetails, setSelectedProductDetails] = useState({
//         subcategoryId: '',
//         // productName: '',
//         productCode: ''
//     });

//     const [selectedproductName, setSelectedProductName] = useState('');
//     const [Aroma, setAroma] = useState('');
//     const [caption, setCaption] = useState('');
//     const [description, setDescription] = useState('');
//     // const [productName, setProductName] = useState('');
//     const [users, setUsers] = useState('');
//     const [sizes, setSizes] = useState([{ size: '', quantity: '', price: '', offer: '', sellingPrice: '' }]);
//     const [images, setImages] = useState([]);
//     const [message, setMessage] = useState('');

//     // Fetch categories with debug logging
//     useEffect(() => {
//         const fetchCategories = async () => {
//             try {
//                 const response = await axios.get('/api/categories');
//                 console.log('Fetched categories:', response.data);
//                 setCategories(response.data);
//             } catch (error) {
//                 console.error('Error fetching categories:', error);
//                 setMessage('Error loading categories');
//             }
//         };
//         fetchCategories();
//     }, []);

//     // Fetch products when category is selected
//     useEffect(() => {
//         if (selectedCategory) {
//             const fetchProducts = async () => {
//                 try {
//                     const response = await axios.get(`/api/products/${selectedCategory}`);
//                     console.log('Fetched products:', response.data);
//                     // setProductName(response.data);
//                 } catch (error) {
//                     console.error('Error fetching products:', error);
//                     setMessage('Error loading products');
//                 }
//             };
//             fetchProducts();
//         } else {
//             setProductName([]);
//         }
//     }, [selectedCategory]);

//     // const handleCategoryChange = (e) => {
//     //     const selectedId = e.target.value;
//     //     console.log('Selected category ID:', selectedId);
        
//     //     if (selectedId) {
//     //         const selectedCat = categories.find(cat => String(cat.categoryId) === String(selectedId));
//     //         console.log('Found category:', selectedCat);
            
//     //         if (selectedCat) {
//     //             setSelectedCategory(selectedId);
//     //             setSelectedCategoryDetails({
//     //                 categoryId: selectedCat.categoryId,
//     //                 categoryName: selectedCat.categoryName,
//     //                 categoryCode: selectedCat.categoryCode
//     //             });
//     //         }
//     //     } else {
//     //         // Reset category selection
//     //         setSelectedCategory('');
//     //         setSelectedCategoryDetails({
//     //             categoryId: '',
//     //             categoryName: '',
//     //             categoryCode: ''
//     //         });
//     //     }
//     // };
//     const handleCategoryChange = (e) => {
//         const selectedId = e.target.value;
//         console.log('Selected category ID:', selectedId);
        
//         if (selectedId) {
//             const selectedCat = categories.find(cat => String(cat.categoryId) === String(selectedId));
//             console.log('Found category:', selectedCat);
            
//             if (selectedCat) {
//                 // Ensure we're getting the correct property name for categoryCode
//                 const categoryCode = selectedCat.categoryCode || selectedCat.CategoryCode;
                
//                 setSelectedCategory(selectedId);
//                 setSelectedCategoryDetails({
//                     categoryId: selectedCat.categoryId,
//                     categoryName: selectedCat.categoryName,
//                     categoryCode: categoryCode // Use the correct property
//                 });
    
//                 // Debug log to verify the data
//                 console.log('Set category details:', {
//                     categoryId: selectedCat.categoryId,
//                     categoryName: selectedCat.categoryName,
//                     categoryCode: categoryCode
//                 });
//             }
//         } else {
//             setSelectedCategory('');
//             setSelectedCategoryDetails({
//                 categoryId: '',
//                 categoryName: '',
//                 categoryCode: ''
//             });
//         }
//     };
    
//     const handleAddSize = () => {
//         setSizes([...sizes, { size: '', quantity: '', price: '', offer: '', sellingPrice: '' }]);
//     };
//     const handleProductChange = (e) => {
//         const selectedId = e.target.value;
        
//         if (selectedId) {
//             const selectedProd = productName.find(prod => String(prod._id) === String(selectedId));
            
//             if (selectedProd) {
//                 setSelectedProductName(selectedId);
//                 setSelectedProductDetails({
//                     subcategoryId: selectedProd._id,
//                     productName: selectedProd.productName,
//                     productCode: selectedProd.productCode
//                 });
                
//                 // Debug log to verify the data
//                 console.log('Set product details:', {
//                     subcategoryId: selectedProd._id,
//                     productName: selectedProd.productName,
//                     productCode: selectedProd.productCode
//                 });
//             }
//         } else {
//             setSelectedProductName('');
//             setSelectedProductDetails({
//                 subcategoryId: '',
//                 productName: '',
//                 productCode: ''
//             });
//         }
//     };


//     const handleSizeChange = (index, field, value) => {
//         const updatedSizes = [...sizes];
//         updatedSizes[index][field] = value;

//         if (field === 'price' || field === 'offer') {
//             const price = parseFloat(updatedSizes[index].price || 0);
//             const offer = parseFloat(updatedSizes[index].offer || 0);
//             updatedSizes[index].sellingPrice = (price - (price * (offer / 100))).toFixed(2);
//         }

//         setSizes(updatedSizes);
//     };

//     const handleImageChange = (e) => {
//         setImages([...e.target.files]);
//     };
//     const [selectedUnits, setSelectedUnits] = useState(sizes.map(() => ''));

//   // Handle unit selection
//   const handleUnitChange = (index, value) => {
//     const newSelectedUnits = [...selectedUnits];
//     newSelectedUnits[index] = value;
//     setSelectedUnits(newSelectedUnits);

//     // Reset size value when unit changes
//     handleSizeChange(index, 'size', '');
//   };

//   // Validate size input based on selected unit
//   const validateSizeInput = (value, unit) => {
//     if (unit === 'ml') {
//       // Allow only numbers up to 3 digits for ml
//       return value.replace(/[^\d]/g, '').slice(0, 3);
//     } else if (unit === 'L') {
//       // Allow decimal numbers for L (up to 2 decimal places)
//       const numericValue = value.replace(/[^\d.]/g, '');
//       const parts = numericValue.split('.');
//       if (parts.length > 2) return parts[0] + '.' + parts[1];
//       return numericValue;
//     }
//     return value;
//   };


//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         console.log('Form submission started');
//         console.log('Category details:', selectedCategoryDetails);

//         const formData = new FormData();
//         // formData.append('subcategoryId', selectedProductDetails.subcategoryId);
//         formData.append('productName', productName);
//         formData.append('productCode',productCode);
//         // Add category details
//         formData.append('categoryId', selectedCategoryDetails.categoryId);
//         formData.append('categoryName', selectedCategoryDetails.categoryName);
//         formData.append('categoryCode', selectedCategoryDetails.categoryCode);
//         formData.append('subcategoryId', selectedproductName);
//         formData.append('Aroma', Aroma);
//         formData.append('caption', caption);
//         formData.append('description', description);
//         formData.append('users', users);
//         // formData.append('sizes', JSON.stringify(sizes));
//         const sizesWithUnits = sizes.map((size, index) => ({
//             ...size,
//             unit: selectedUnits[index],
//             size: `${size.size}${selectedUnits[index]}`  // Combine size with unit
//         }));
//         formData.append('sizes', JSON.stringify(sizesWithUnits));
//         // Add images
//         for (let image of images) {
//             formData.append('images', image);
//         }

//         // Log form data for debugging
//         for (let pair of formData.entries()) {
//             console.log(pair[0], pair[1]);
//         }

//         try {
//             const response = await axios.post('/api/add-product', formData, {
//                 headers: { 'Content-Type': 'multipart/form-data' },
//             });

//             console.log('Server response:', response.data);
//             setMessage('Product added successfully!');

//             // Reset form
//             setAroma('');
//             setCaption('');
//             setDescription('');
//             setUsers('');
//             setSizes([{ size: '', quantity: '', price: '', offer: '', sellingPrice: '' }]);
//             setImages([]);
//             setSelectedCategory('');
//             setSelectedCategoryDetails({
//                 categoryId: '',
//                 categoryName: '',
//                 categoryCode: ''
//             });
//             setSelectedProductName('');
//         } catch (error) {
//             console.error('Submission error:', error);
//             setMessage('Failed to add product.');
//         }
//     };

// //     return (
// //         <div>
// //             <div className="content-wrapper">
// //                 <LeftSideNavaBarAdmin />
// //                 <div className="admin-product-form">
// //                     <h2>Add Product</h2>
// //                     {message && <p className="message">{message}</p>}
// //                     <form onSubmit={handleSubmit}>
// //                         <div className="form-group">
// //                             <label>Category:</label>
// //                             <select
// //                                 value={selectedCategory}
// //                                 onChange={handleCategoryChange}
// //                                 required
// //                             >
// //                                 <option value="">Select a Category</option>
// //                                 {categories && categories.map((category) => (
// //                                     <option 
// //                                         key={category.categoryId} 
// //                                         value={category.categoryId}
// //                                     >
// //                                         {category.categoryName}
// //                                     </option>
// //                                 ))}
// //                             </select>
// //                         </div>

// //                         <div className="form-group">
// //                             {/* <label>Product Name:</label>
// //                             <select
// //                                 value={selectedproductName}
// //                                 onChange={(e) => setSelectedProductName(e.target.value)}
// //                                 required
// //                                 disabled={!selectedCategory}
// //                             >
// //                                 <option value="">Select a Product</option>
// //                                 {productName && productName.map((product) => (
// //                                     <option 
// //                                         key={product.subcategoryId} 
// //                                         value={product.subcategoryId}
// //                                     >
// //                                         {product.productName}
// //                                     </option>
// //                                 ))}
// //                             </select> */}

// // <label>Product Name:</label>
// //                         <select
// //                             value={selectedproductName}
// //                             onChange={handleProductChange}
// //                             required
// //                             disabled={!selectedCategory}
// //                         >
// //                             <option value="">Select a Product</option>
// //                             {productName && productName.map((product) => (
// //                                 <option 
// //                                     key={product._id} 
// //                                     value={product._id}
// //                                 >
// //                                     {product.productName}
// //                                 </option>
// //                             ))}
// //                         </select>
// //                         </div>

// //                         <div className="form-group">
// //                             <label>Aroma:</label>
// //                             <input
// //                                 type="text"
// //                                 value={Aroma}
// //                                 onChange={(e) => setAroma(e.target.value)}
// //                                 required
// //                             />
// //                         </div>

// //                         <div className="form-group">
// //                             <label>Caption:</label>
// //                             <input
// //                                 type="text"
// //                                 value={caption}
// //                                 onChange={(e) => setCaption(e.target.value)}
// //                                 required
// //                             />
// //                         </div>

// //                         <div className="form-group">
// //                             <label>Description:</label>
// //                             <textarea
// //                                 value={description}
// //                                 onChange={(e) => setDescription(e.target.value)}
// //                                 required
// //                             ></textarea>
// //                         </div>

// //                         <div className="form-group">
// //                             <label>Users:</label>
// //                             <textarea
// //                                 value={users}
// //                                 onChange={(e) => setUsers(e.target.value)}
// //                                 required
// //                             ></textarea>
// //                         </div>

// //                         {/* <div className="sizes-section">
// //                             <h3>Sizes:</h3>
// //                             {sizes.map((size, index) => (
// //                                 <div key={index} className="size-inputs">
// //                                     <input
// //                                         type="text"
// //                                         placeholder="Size"
// //                                         value={size.size}
// //                                         onChange={(e) => handleSizeChange(index, 'size', e.target.value)}
// //                                     />
// //                                     <input
// //                                         type="number"
// //                                         placeholder="Quantity"
// //                                         value={size.quantity}
// //                                         onChange={(e) => handleSizeChange(index, 'quantity', e.target.value)}
// //                                     />
// //                                     <input
// //                                         type="number"
// //                                         placeholder="Price"
// //                                         value={size.price}
// //                                         onChange={(e) => handleSizeChange(index, 'price', e.target.value)}
// //                                     />
// //                                     <input
// //                                         type="number"
// //                                         placeholder="Offer (%)"
// //                                         value={size.offer}
// //                                         onChange={(e) => handleSizeChange(index, 'offer', e.target.value)}
// //                                     />
// //                                     <input
// //                                         type="number"
// //                                         placeholder="Selling Price"
// //                                         value={size.sellingPrice}
// //                                         readOnly
// //                                     />
// //                                 </div>
// //                             ))}
// //                             <button type="button" onClick={handleAddSize}>Add Size</button>
// //                         </div> */}
// //                           <div className="sizes-section">
// //       <h3 className="text-lg font-semibold mb-4">Sizes:</h3>
// //       {sizes.map((size, index) => (
// //         <div key={index} className="size-inputs flex gap-4 mb-4">
// //           <select
// //             className="p-2 border rounded"
// //             value={selectedUnits[index]}
// //             onChange={(e) => handleUnitChange(index, e.target.value)}
// //           >
// //             <option value="">Select Unit</option>
// //             <option value="ml">ml</option>
// //             <option value="L">L</option>
// //           </select>

// //           <input
// //             type="text"
// //             placeholder="Size"
// //             value={size.size}
// //             disabled={!selectedUnits[index]}
// //             required
// //             onChange={(e) => {
// //               const validatedValue = validateSizeInput(e.target.value, selectedUnits[index]);
// //               handleSizeChange(index, 'size', validatedValue);
// //             }}
// //             className="p-2 border rounded"
// //           />

// //           <input
// //             type="number"
// //             placeholder="Quantity"
// //             value={size.quantity}
// //             required
// //             disabled={!selectedUnits[index]}
// //             onChange={(e) => handleSizeChange(index, 'quantity', e.target.value)}
// //             className="p-2 border rounded"
// //           />

// //           <input
// //             type="number"
// //             placeholder="Price"
// //             value={size.price}
// //             required
// //             disabled={!selectedUnits[index]}
// //             onChange={(e) => handleSizeChange(index, 'price', e.target.value)}
// //             className="p-2 border rounded"
// //           />

// //           <input
// //             type="number"
// //             placeholder="Offer (%)"
// //             value={size.offer}
// //             disabled={!selectedUnits[index]}
// //             onChange={(e) => handleSizeChange(index, 'offer', e.target.value)}
// //             className="p-2 border rounded"
// //           />

// //           <input
// //             type="number"
// //             placeholder="Selling Price"
// //             value={size.sellingPrice}
// //             readOnly
// //             className="p-2 border rounded bg-gray-100"
// //           />
// //         </div>
// //       ))}
// //       <button
// //         type="button"
// //         onClick={() => {
// //           handleAddSize();
// //           setSelectedUnits([...selectedUnits, '']);
// //         }}
// //         className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
// //       >
// //         Add Size
// //       </button>
// //     </div>

// //                         <div className="form-group">
// //                             <label>Images:</label>
// //                             <input
// //                                 type="file"
// //                                 multiple
// //                                 onChange={handleImageChange}
// //                                 required
// //                             />
// //                         </div>

// //                         <button type="submit">Add Product</button>
// //                     </form>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };


// return (
//     <>
//              <div class="breadcrumb-wrap bg-f br-1">

//          </div>
//     <div className="containerorder">
    
//     <div className="row">
//           <div class="col-xl-2 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
//             <LeftSideNavaBarAdmin /></div>
            
//             <div className="col-xl-10 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1 ">
//                 <h2 className="product-admin-title">
//                     <Package size={24} />
//                     Add Product
//                 </h2>
                
//                 {message && (
//                     <p className={`product-admin-message ${
//                         message.includes('success') 
//                         ? 'product-admin-message-success' 
//                         : 'product-admin-message-error'
//                     }`}>
//                         {message.includes('success') 
//                             ? <CheckCircle2 size={20} /> 
//                             : <AlertCircle size={20} />
//                         }
//                         {message}
//                     </p>
//                 )}

//                 <form onSubmit={handleSubmit}>
//                     <div className="product-admin-form-group">
//                         <label className="product-admin-label">
//                             <Layers size={20} />
//                             Category:
//                         </label>
//                         <select
//                             className="product-admin-select"
//                             value={selectedCategory}
//                             onChange={handleCategoryChange}
//                             required
//                         >
//                             <option value="">Select a Category</option>
//                             {categories?.map((category) => (
//                                 <option 
//                                     key={category.categoryId} 
//                                     value={category.categoryId}
//                                 >
//                                     {category.categoryName}
//                                 </option>
//                             ))}
//                         </select>
//                     </div>


//                     <div className="product-admin-form-group">
//                         <label className="product-admin-label">
//                             <Tags size={20} />
//                             ProductName:
//                         </label>
//                         <input
//                             type="text"
//                             className="product-admin-input"
//                             value={productName}
//                             onChange={(e) =>setProductName (e.target.value)}
//                             required
//                         />
//                     </div>
//                     <div className="product-admin-form-group">
//                         <label className="product-admin-label">
//                             <Tags size={20} />
//                             Enter Product Code:
//                         </label>
//                         <input
//                             type="text"
//                             className="product-admin-input"
//                             value={productCode}
//                             onChange={(e) =>setproductCode (e.target.value)}
//                             required
//                         />
//                     </div>

//                     {/* <div className="product-admin-form-group">
//                         <label className="product-admin-label">
//                             <Package size={20} />
//                             Product Name:
//                         </label>
//                         <select
//                             className="product-admin-select"
//                             value={selectedproductName}
//                             onChange={handleProductChange}
//                             required
//                             disabled={!selectedCategory}
//                         >
//                             <option value="">Select a Product</option>
//                             {productName?.map((product) => (
//                                 <option 
//                                     key={product._id} 
//                                     value={product._id}
//                                 >
//                                     {product.productName}
//                                 </option>
//                             ))}
//                         </select>
//                     </div> */}

//                     <div className="product-admin-form-group">
//                         <label className="product-admin-label">
//                             <Tags size={20} />
//                             Aroma:
//                         </label>
//                         <input
//                             type="text"
//                             className="product-admin-input"
//                             value={Aroma}
//                             onChange={(e) => setAroma(e.target.value)}
//                             required
//                         />
//                     </div>

//                     <div className="product-admin-form-group">
//                         <label className="product-admin-label">
//                             <FileText size={20} />
//                             Caption:
//                         </label>
//                         <input
//                             type="text"
//                             className="product-admin-input"
//                             value={caption}
//                             onChange={(e) => setCaption(e.target.value)}
//                             required
//                         />
//                     </div>

//                     <div className="product-admin-form-group">
//                         <label className="product-admin-label">
//                             <FileText size={20} />
//                             Description:
//                         </label>
//                         <textarea
//                             className="product-admin-textarea"
//                             value={description}
//                             onChange={(e) => setDescription(e.target.value)}
//                             required
//                         ></textarea>
//                     </div>

//                     <div className="product-admin-form-group">
//                         <label className="product-admin-label">
//                             <Users size={20} />
//                             Usess:
//                         </label>
//                         <textarea
//                             className="product-admin-textarea"
//                             value={users}
//                             onChange={(e) => setUsers(e.target.value)}
//                             required
//                         ></textarea>
//                     </div>

//                     <div className="product-admin-sizes">
//                         <h3 className="product-admin-sizes-title">
//                             <Ruler size={20} />
//                             Sizes:
//                         </h3>
//                         {sizes.map((size, index) => (
//                             <div key={index} className="product-admin-size-row">
//                                 <select
//                                     className="product-admin-size-input"
//                                     value={selectedUnits[index]}
//                                     onChange={(e) => handleUnitChange(index, e.target.value)}
//                                 >
//                                     <option value="">Select Unit</option>
//                                     <option value="ml">ml</option>
//                                     <option value="L">l</option>
//                                 </select>

//                                 <input
//                                     type="text"
//                                     placeholder="Size"
//                                     className="product-admin-size-input"
//                                     value={size.size}
//                                     disabled={!selectedUnits[index]}
//                                     onChange={(e) => {
//                                         const validatedValue = validateSizeInput(e.target.value, selectedUnits[index]);
//                                         handleSizeChange(index, 'size', validatedValue);
//                                     }}
//                                     required
//                                 />
                                
//                                 <input
//                                     type="number"
//                                     placeholder="Quantity"
//                                     className="product-admin-size-input"
//                                     value={size.quantity}
//                                     onChange={(e) => handleSizeChange(index, 'quantity', e.target.value)}
//                                     required
//                                 />

//                                 <input
//                                     type="number"
//                                     placeholder="Price"
//                                     className="product-admin-size-input"
//                                     value={size.price}
//                                     onChange={(e) => handleSizeChange(index, 'price', e.target.value)}
//                                     required
//                                 />

//                                 <input
//                                     type="number"
//                                     placeholder="Offer (%)"
//                                     className="product-admin-size-input"
//                                     value={size.offer}
//                                     onChange={(e) => handleSizeChange(index, 'offer', e.target.value)}
//                                 />

//                                 <input
//                                     type="number"
//                                     placeholder="Selling Price"
//                                     className="product-admin-size-input"
//                                     value={size.sellingPrice}
//                                     readOnly
//                                 />
//                             </div>
//                         ))}
//                         <button
//                             type="button"
//                             className="product-admin-button product-admin-add"
//                             onClick={() => {
//                                 handleAddSize();
//                                 setSelectedUnits([...selectedUnits, '']);
//                             }}
//                         >
//                             <Plus size={20} />
//                             Add Size
//                         </button>
//                     </div>

//                     <div className="product-admin-form-group">
//                         <label className="product-admin-label">
//                             <ImageIcon size={20} />
//                             Images:
//                         </label>
//                         <input
//                             type="file"
//                             className="product-admin-file-input"
//                             multiple
//                             onChange={handleImageChange}
//                             required
//                         />
//                     </div>

//                     <button type="submit" className="product-admin-button product-admin-submit">
//                         <Save size={20} />
//                         Add Product
//                     </button>
//                 </form>
//             </div>
//         </div>
//     </div></>
// );
// };


// export default Product;




import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LeftSideNavaBarAdmin from './LeftSideNavaBarAdmin';
import './AddProduct.css';

import { useRef } from 'react';
import { 
    Package,
    Tags,
    FileText, 
    Users, 
    Image as ImageIcon,
    Ruler,
    Plus,
    Save,
    Layers,
    AlertCircle,
    CheckCircle2,
    X
  } from 'lucide-react';
import AdminTopNavbar from './AdminTopNavbar';




const Product = () => {
    const [categories, setCategories] = useState([]);
    const [productName, setProductName] = useState('');
    const [productCode, setproductCode] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const fileInputRef = useRef(null); // Create a ref for the file input
    const [aromas, setAromas] = useState([
        { 
            name: '', 
            images: [],
            sizes: [{ 
                size: '', 
                unit: '',
                quantity: '', 
                price: '', 
                offer: '', 
                sellingPrice: '' 
            }]
        }
    ]);
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.get('/api/categories');
                setCategories(response.data);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };
        fetchCategories();
    }, []);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.get('/api/categories');
                console.log('Fetched categories:', response.data);
                setCategories(response.data);
            } catch (error) {
                console.error('Error fetching categories:', error);
                setMessage('Error loading categories');
            }
        };
        fetchCategories();
    }, []);






    // Modified handleAddAroma to include sizes array

    const [selectedCategoryDetails, setSelectedCategoryDetails] = useState({
        categoryId: '',
        categoryName: '',
        categoryCode: ''
    });

    const [images, setImages] = useState([]);
    const [message, setMessage] = useState('');
    const [selectedproductName, setSelectedProductName] = useState('');
    const [caption, setCaption] = useState('');
    const [description, setDescription] = useState('');
    const [uses, setUses] = useState('');
    const [keyFeatures, setKeyFeatures] = useState('');
const [ingredients, setIngredients] = useState('');
const [howToUse, setHowToUse] = useState('');
const [customerReviews, setCustomerReviews] = useState('');

    const [sizes, setSizes] = useState([{ size: '', quantity: '', price: '', offer: '', sellingPrice: '' }]);

    const [selectedUnits, setSelectedUnits] = useState(['']);
    // Existing category fetch useEffect remains the same...
   



    // Handle image uploads for a specific aroma
    const handleAromaImageChange = (index, files) => {
        const newAromas = [...aromas];
        // Convert FileList to array and add to existing images
        const fileArray = Array.from(files);
        newAromas[index].images = [...newAromas[index].images, ...fileArray];
        setAromas(newAromas);
    };
    
    // Remove an image from an aroma
    const handleRemoveAromaImage = (aromaIndex, imageIndex) => {
        const newAromas = [...aromas];
        newAromas[aromaIndex].images.splice(imageIndex, 1);
        setAromas(newAromas);
    };






    const handleImageChange = (e) => {
        setImages([...e.target.files]);
    };

    // Handle unit selection


    const validateSizeInput = (value, unit) => {
        if (unit === 'ml' || unit === 'mg') {
            // Allow only numbers up to 3 digits for ml and mg
            return value.replace(/[^\d]/g, '').slice(0, 3);
        } else if (unit === 'g') {
            // Allow only numbers up to 4 digits for grams
            return value.replace(/[^\d]/g, '').slice(0, 4);
        } else if (unit === 'kg' || unit === 'L') {
            // Allow decimal numbers for kg and L (up to 2 decimal places)
            const numericValue = value.replace(/[^\d.]/g, ''); // Allow only numbers and a single dot
            const parts = numericValue.split('.');
            if (parts.length > 2) {
                // If there are multiple dots, keep only the first two parts
                return parts[0] + '.' + parts[1].slice(0, 2);
            }
            if (parts[1]?.length > 2) {
                // Limit the decimal part to 2 digits
                return parts[0] + '.' + parts[1].slice(0, 2);
            }
            return numericValue;
        }
        return value;
    };

 
  


 
 
   const handleAddProduct = async () => {
        const filteredAromas = aromas.filter(aroma => aroma.name.trim() !== '');

        if (filteredAromas.length === 0) {
            setMessage('Please add at least one aroma with a name.');
            return;
        }

        for (const aroma of filteredAromas) {
            const validSizes = (aroma.sizes || []).filter(
                size => size.size && size.unit && size.quantity !== '' && size.price !== ''
            );
            if (validSizes.length === 0) {
                setMessage(`Please add at least one complete size for "${aroma.name}".`);
                return;
            }
        }

    const formData = new FormData();
        
        // Add basic product info
        formData.append('productName', productName);
        formData.append('productCode', productCode);
        formData.append('categoryId', selectedCategoryDetails.categoryId);
        formData.append('categoryName', selectedCategoryDetails.categoryName);
        formData.append('categoryCode', selectedCategoryDetails.categoryCode);
        formData.append('caption', caption);
        formData.append('description', description);
        formData.append('uses', uses);
        formData.append('keyFeatures', keyFeatures);
formData.append('ingredients', ingredients);
formData.append('howToUse', howToUse);
formData.append('customerReviews', customerReviews);

        
        // Add aroma images with proper field names
        filteredAromas.forEach((aroma) => {
            aroma.images.forEach((image) => {
                formData.append('aromaImages', image);
            });
        });

        // Filter and process aromas with their sizes
        const aromasMetadata = filteredAromas.map(aroma => ({
            name: aroma.name,
            imageCount: aroma.images.length,
            sizes: aroma.sizes
                .filter(size => size.size && size.unit && size.quantity !== '' && size.price !== '')
                .map(size => ({
                size: size.size,
                unit: size.unit,
                quantity: Number(size.quantity),
                price: Number(size.price),
                offer: Number(size.offer || 0),
                sellingPrice: Number(size.sellingPrice || size.price)
            }))
        }));
        formData.append('aromasMetadata', JSON.stringify(aromasMetadata));
        
        // Add main product images
        if (images.length > 0) {
            images.forEach(image => {
                formData.append('images', image);
            });
        }
    
        // Log FormData contents for debugging
        for (let pair of formData.entries()) {
            console.log(pair[0], pair[1]);
        }
        
        try {
            const response = await axios.post('/api/add-product', formData, {
                headers: { 
                    'Content-Type': 'multipart/form-data'
                },
            });
            
            console.log('Server response:', response.data);
            setMessage('Product added successfully!');
            resetForm();
        } catch (error) {
            console.error('Submission error:', error);
            setMessage('Failed to add product.');
        }
    };
    
  
    const resetForm = () => {
        setAromas([
            { 
                name: '', 
                images: [],
                sizes: [{ 
                    size: '', 
                    unit: '',
                    quantity: '', 
                    price: '', 
                    offer: '', 
                    sellingPrice: '' 
                }]
            }
        ]);
        setCaption('');
        setDescription('');
        setUses('');
        setKeyFeatures('');
setIngredients('');
setHowToUse('');
setCustomerReviews('');

        setSizes([{ size: '', unit: '', quantity: '', price: '', offer: '', sellingPrice: '' }]); // Ensure unit is included
        setSelectedUnits(['']);
        setImages([]);
        setSelectedCategory('');
        setProductName('');

        setSelectedCategoryDetails({
            categoryId: '',
            categoryName: '',
            categoryCode: ''
        });
        setSelectedProductName('');
        if (fileInputRef.current) {
            fileInputRef.current.value = '';  // Clear the file input
        }
    };
    


      const handleAromaChange = (index, value) => {
        const newAromas = [...aromas];
        newAromas[index].name = value;
        setAromas(newAromas);
    };

    const handleAddAroma = () => {
        setAromas([...aromas, {
            name: '',
            images: [],
            sizes: [{
                size: '',
                unit: '',
                quantity: '',
                price: '',
                offer: '',
                sellingPrice: ''
            }]
        }]);
    };

    const handleRemoveAroma = (index) => {
        if (aromas.length > 1) {
            const newAromas = [...aromas];
            newAromas.splice(index, 1);
            setAromas(newAromas);
        }
    };

    const handleAddSize = (aromaIndex) => {
        const newAromas = [...aromas];
        if (!newAromas[aromaIndex].sizes) {
            newAromas[aromaIndex].sizes = [];
        }
        newAromas[aromaIndex].sizes.push({
            size: '',
            unit: '',
            quantity: '',
            price: '',
            offer: '',
            sellingPrice: ''
        });
        setAromas(newAromas);
    };

    const handleSizeChange = (aromaIndex, sizeIndex, field, value) => {
        const newAromas = [...aromas];
        if (!newAromas[aromaIndex].sizes) {
            newAromas[aromaIndex].sizes = [];
        }
        if (!newAromas[aromaIndex].sizes[sizeIndex]) {
            newAromas[aromaIndex].sizes[sizeIndex] = {
                size: '',
                unit: '',
                quantity: '',
                price: '',
                offer: '',
                sellingPrice: ''
            };
        }
        
        newAromas[aromaIndex].sizes[sizeIndex][field] = value;

        // Calculate selling price if price or offer changes
        if (field === 'price' || field === 'offer') {
            const size = newAromas[aromaIndex].sizes[sizeIndex];
            const price = parseFloat(size.price || 0);
            const offer = parseFloat(size.offer || 0);
            size.sellingPrice = Math.floor(price - (price * (offer / 100)));
        }

        setAromas(newAromas);
    };

    const handleUnitChange = (aromaIndex, sizeIndex, value) => {
        const newAromas = [...aromas];
        if (!newAromas[aromaIndex].sizes) {
            newAromas[aromaIndex].sizes = [];
        }
        if (!newAromas[aromaIndex].sizes[sizeIndex]) {
            newAromas[aromaIndex].sizes[sizeIndex] = {
                size: '',
                unit: '',
                quantity: '',
                price: '',
                offer: '',
                sellingPrice: ''
            };
        }
        newAromas[aromaIndex].sizes[sizeIndex].unit = value;
        newAromas[aromaIndex].sizes[sizeIndex].size = ''; // Reset size when unit changes
        setAromas(newAromas);
    };
      const renderSizeFields = (aromaIndex) => {
        // Ensure sizes array exists
        const aroma = aromas[aromaIndex];
        if (!aroma || !aroma.sizes) return null;

        return (
            <div className="product-admin-sizes">
                <h4 className="product-admin-sizes-subtitle">Sizes for {aroma.name || 'Aroma'}:</h4>
                {aroma.sizes.map((size, sizeIndex) => (
                    <div key={sizeIndex} className="product-admin-size-row">
                        <select
                            className="product-admin-size-input"
                            value={size.unit || ''}
                            onChange={(e) => handleUnitChange(aromaIndex, sizeIndex, e.target.value)}
                        >
                            <option value="">Select Unit</option>
                            <option value="ml">ml</option>
                            <option value="L">l</option>
                            <option value="mg">mg</option>
                            <option value="g">gms</option>
                            <option value="kg">kg</option>
                        </select>

                        <input
                            type="text"
                            placeholder="Size"
                            className="product-admin-size-input"
                            value={size.size || ''}
                            disabled={!size.unit}
                            onChange={(e) => {
                                const validatedValue = validateSizeInput(e.target.value, size.unit);
                                handleSizeChange(aromaIndex, sizeIndex, 'size', validatedValue);
                            }}
                            required
                        />
                        
                        <input
                            type="number"
                            placeholder="Quantity"
                            className="product-admin-size-input"
                            value={size.quantity || ''}
                            onChange={(e) => handleSizeChange(aromaIndex, sizeIndex, 'quantity', e.target.value)}
                            required
                        />

                        <input
                            type="number"
                            placeholder="Price"
                            className="product-admin-size-input"
                            value={size.price || ''}
                            onChange={(e) => handleSizeChange(aromaIndex, sizeIndex, 'price', e.target.value)}
                            required
                        />

                        <input
                            type="number"
                            placeholder="Offer (%)"
                            className="product-admin-size-input"
                            value={size.offer || ''}
                            onChange={(e) => handleSizeChange(aromaIndex, sizeIndex, 'offer', e.target.value)}
                        />

                        <input
                            type="number"
                            placeholder="Selling Price"
                            className="product-admin-size-input"
                            value={size.sellingPrice || ''}
                            readOnly
                        />
                    </div>
                ))}
                <button
                    type="button"
                    className="product-admin-button product-admin-add"
                    onClick={() => handleAddSize(aromaIndex)}
                >
                    <Plus size={16} />
                    Add Size
                </button>
            </div>
        );
    };
    const handleCategoryChange = (e) => {
        const selectedId = e.target.value;
        console.log('Selected category ID:', selectedId);
        
        if (selectedId) {
            const selectedCat = categories.find(cat => String(cat.categoryId) === String(selectedId));
            console.log('Found category:', selectedCat);
            
            if (selectedCat) {
                // Ensure we're getting the correct property name for categoryCode
                const categoryCode = selectedCat.categoryCode || selectedCat.CategoryCode;
                
                setSelectedCategory(selectedId);
                setSelectedCategoryDetails({
                    categoryId: selectedCat.categoryId,
                    categoryName: selectedCat.categoryName,
                    categoryCode: categoryCode // Use the correct property
                });
    
                // Debug log to verify the data
                console.log('Set category details:', {
                    categoryId: selectedCat.categoryId,
                    categoryName: selectedCat.categoryName,
                    categoryCode: categoryCode
                });
            }
        } else {
            setSelectedCategory('');
            setSelectedCategoryDetails({
                categoryId: '',
                categoryName: '',
                categoryCode: ''
            });
        }
    };
    const renderAromaSection = () => (
        <div className="product-admin-form-group">
            <label className="product-admin-label">
                <Tags size={20} />
                Aromas with Images and Sizes:
            </label>
            <div className="product-admin-aromas">
                {aromas.map((aroma, aromaIndex) => (
                    <div key={aromaIndex} className="product-admin-aroma-container">
                        <div className="product-admin-aroma-row">
                            <input
                                type="text"
                                className="product-admin-input"
                                placeholder={`Aroma ${aromaIndex + 1}`}
                                value={aroma.name}
                                onChange={(e) => handleAromaChange(aromaIndex, e.target.value)}
                                required={aromaIndex === 0}
                            />
                            {aromaIndex > 0 && (
                                <button
                                    type="button"
                                    className="product-admin-button product-admin-remove"
                                    onClick={() => handleRemoveAroma(aromaIndex)}
                                >
                                    <X size={16} />
                                </button>
                            )}
                        </div>
                        
                        {/* Image upload section */}
                        <div className="product-admin-aroma-images">
                            <div className="product-admin-image-upload">
                                <label className="product-admin-image-label">
                                    <ImageIcon size={16} />
                                    {aroma.name || 'Aroma'} Images:
                                    <input
                                        type="file"
                                        ref={fileInputRef}  
                                        className="product-admin-file-input"
                                        multiple
                                        onChange={(e) => handleAromaImageChange(aromaIndex, e.target.files)}
                                    />
                                </label>
                            </div>
                            
                            {/* Image previews */}
                            {aroma.images.length > 0 && (
                                <div className="product-admin-image-previews">
                                    {aroma.images.map((image, imageIndex) => (
                                        <div key={imageIndex} className="product-admin-image-preview">
                                            <img 
                                                src={URL.createObjectURL(image)} 
                                                alt={`${aroma.name || 'Aroma'} preview ${imageIndex}`}
                                                className="product-admin-preview-img"
                                            />
                                            <button
                                                type="button"
                                                className="product-admin-image-remove"
                                                onClick={() => handleRemoveAromaImage(aromaIndex, imageIndex)}
                                            >
                                                <X size={18} />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Size fields for this aroma */}
                        {renderSizeFields(aromaIndex)}
                    </div>
                ))}
                <button
                    type="button"
                    className="product-admin-button product-admin-add"
                    onClick={handleAddAroma}
                >
                    <Plus size={16} />
                    Add Another Aroma
                </button>
            </div>
        </div>
    );


    return (
        <>
           <AdminTopNavbar/>
           <div>
            <div className="product-admin-wrapper" style={{ paddingTop: '250px' }}>
                <div className="row addp">
                <div className="col-xl-3 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-1">
                    <LeftSideNavaBarAdmin />
                    </div>
                    <div className="col-xl-8 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2 product-admin-form">
    <h2 className="product-admin-title">
        <Package size={24} />
        Add Product
    </h2>

    {message && (
        <p className={`product-admin-message ${
            message.includes('success') 
            ? 'product-admin-message-success' 
            : 'product-admin-message-error'
        }`}>
            {message.includes('success') 
                ? <CheckCircle2 size={20} /> 
                : <AlertCircle size={20} />
            }
            {message}
        </p>
    )}

    <div className='product_form_karthik'>   
        <div className='product-admin-sizes'>
            <div className="product-admin-form-group">
                <label className="product-admin-label">
                    <Layers size={20} />
                    Category:
                </label>
                <select
                    className="product-admin-select"
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    required
                >
                    <option value="">Select a Category</option>
                    {categories?.map((category) => (
                        <option 
                            key={category.categoryId} 
                            value={category.categoryId}
                        >
                            {category.categoryName}
                        </option>
                    ))}
                </select>
            </div>

            <div className="product-admin-form-group">
                <label className="product-admin-label">
                    <Tags size={20} />
                    Product Name:
                </label>
                <input
                    type="text"
                    className="product-admin-input"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                    required
                />
            </div>
            
            <div className="product-admin-form-group">
                <label className="product-admin-label">
                    <Tags size={20} />
                    Enter Product Code:
                </label>
                <input
                    type="text"
                    className="product-admin-input"
                    value={productCode}
                    onChange={(e) => setproductCode(e.target.value)}
                    required
                />
            </div>

            <div className="product-admin-form-group">
                <label className="product-admin-label">
                    <FileText size={20} />
                    Caption:
                </label>
                <input
                    type="text"
                    className="product-admin-input"
                    value={caption}
                    onChange={(e) => setCaption(e.target.value)}
                    required
                />
            </div>

            <div className="product-admin-form-group">
                <label className="product-admin-label">
                    <FileText size={20} />
                    Description:
                </label>
                <textarea
                    className="product-admin-textarea"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                ></textarea>
            </div>

            <div className="product-admin-form-group">
                <label className="product-admin-label">
                    <Users size={20} />
                    Uses:
                </label>
                <textarea
                    className="product-admin-textarea"
                    value={uses}
                    onChange={(e) => setUses(e.target.value)}
                    required
                ></textarea>
            </div>

            <div className="product-admin-form-group">
    <label className="product-admin-label">
        <FileText size={20} />
        Key Features:
    </label>
    <textarea
        className="product-admin-textarea"
        value={keyFeatures}
        onChange={(e) => setKeyFeatures(e.target.value)}
    ></textarea>
</div>

<div className="product-admin-form-group">
    <label className="product-admin-label">
        <FileText size={20} />
        Ingredients:
    </label>
    <textarea
        className="product-admin-textarea"
        value={ingredients}
        onChange={(e) => setIngredients(e.target.value)}
    ></textarea>
</div>

<div className="product-admin-form-group">
    <label className="product-admin-label">
        <FileText size={20} />
        How to Use:
    </label>
    <textarea
        className="product-admin-textarea"
        value={howToUse}
        onChange={(e) => setHowToUse(e.target.value)}
    ></textarea>
</div>

<div className="product-admin-form-group">
    <label className="product-admin-label">
        <FileText size={20} />
        Customer Reviews:
    </label>
    <textarea
        className="product-admin-textarea"
        value={customerReviews}
        onChange={(e) => setCustomerReviews(e.target.value)}
    ></textarea>
</div>


           <button 
    className="product-admin-button product-admin-submit"
    onClick={handleAddProduct}
>
    <Save size={20} />
    Add Product
</button>

        </div>

        <div className="product-admin-form-group">
            {renderAromaSection()}
        </div>
    </div>
</div>

                </div>
            </div>
            </div>
        </>
    );
};

export default Product;
